import { httpCreate } from './http';

const http = httpCreate('/srv/advert-video');

export const advertVideo = {
	save(id, data) {
		return http.post(`/${id}`, data);
	},
};
